<template>
  <v-row>
    <v-col
      v-for="(item, i) in tabs"
      :key="i"
      cols="auto"
    >
      <v-btn
        :text="!tab_selected(item)"
        :to="`/catalog/${item.id}`"
      >
        {{ item.name }}
      </v-btn>
    </v-col>
    <v-spacer />
    <v-col
      v-if="selected.length"
      cols="auto"
    >
      <template v-if="id == 'templates'">
        <v-btn
          v-if="selected_publish.length"
          class="full-height"
          :loading="loading"
          @click="publishTemplates"
        >
          Publish ({{ selected_publish.length }})
        </v-btn>
        <v-btn
          v-if="selected_copy.length"
          class="full-height"
          :loading="loading"
          :disabled="disableCopy"
          @click="showCopyTemplates"
        >
          Edit & Copy ({{ selected_copy.length }})
        </v-btn>
      </template>
      <template v-else-if="id == 'copy-templates'">
        <v-btn
          v-if="selected_copy.length"
          class="full-height mr-2"
          :loading="loading"
          :disabled="disableCopy"
          @click="showCopyTemplates"
        >
          Edit & Copy ({{ selected_copy.length }})
        </v-btn>
        <v-btn
          v-if="selected_copy.length"
          class="full-height mr-2"
          :loading="saving"
          @click="copyTemplates"
        >
          Copy ({{ selected_copy.length }})
        </v-btn>
        <v-btn
          v-if="selected_copy.length"
          class="full-height"
          color="error"
          :loading="saving"
          @click="ignoreResize"
        >
          Ignore ({{ selected_copy.length }})
        </v-btn>
      </template>
    </v-col>
    <v-col
      cols="auto"
      class="mt-auto mr-4"
    >
      <v-btn
        v-if="showFilter"
        icon
        small
        class="mr-2"
        @click="filterClicked"
      >
        <v-icon>filter_list</v-icon>
      </v-btn>
      <v-btn
        v-if="showAdd"
        icon
        small
        @click="addClicked"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-col>
    <CatalogAdd />
    <CatalogFilter ref="filter" />
    <TemplateCopy ref="copy" />
  </v-row>
</template>

<script>
import CatalogAdd from '@/components/catalog/Add';
import CatalogFilter from '@/components/catalog/Filter';
import TemplateCopy from '@/components/templates/Copy';
import { uniq } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogHeader',
  components: { CatalogFilter, CatalogAdd, TemplateCopy },
  data() {
    return { loading: false, saving: false };
  },
  computed: {
    tabs() {
      return this.$enums.CATALOG_TABS;
    },
    id() {
      return this.$route.params.id;
    },
    showAdd() {
      return !!this.current_tab.add;
    },
    showFilter() {
      return !!this.current_tab.store;
    },
    current_tab() {
      return this.tabs.find((x) => x.id === this.id);
    },
    tab_selected() {
      return (item) => {
        return this.id === item.id;
      };
    },
    selected_publish() {
      return this.selected.filter((x) => x.canPublish);
    },
    selected_copy() {
      return this.selected.filter((x) => x.published && !x.resizedFromTemplateId);
    },
    disableCopy() {
      return uniq(this.selected_copy.map((x) => x.categoryId)).length > 1;
    },
    ...mapGetters({ filter: 'catalog/filter', selected: 'catalog/selected' })
  },
  methods: {
    addClicked() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_SHOW, {
        typeId: this.id
      });
    },
    filterClicked() {
      this.$refs.filter.show();
    },
    publishTemplates() {
      this.loading = true;
      this.$store
        .dispatch(
          'templates/publishBulk',
          this.selected_publish.map((x) => x.id)
        )
        .then((skipped) => {
          if (skipped && skipped.length) {
            this.$root.$alert(
              `${skipped.length} template(s) skipped`,
              skipped.map((s) => `#${s.templateId}: ${s.reason}`).join('\n')
            );
          } else {
            this.$root.$snackbarSuccess('Templates published');
          }
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showCopyTemplates() {
      this.$refs.copy.show({ templateIds: this.selected_copy.map((x) => x.id) });
    },
    copyTemplates() {
      this.saving = true;
      this.$store
        .dispatch('templates/copyDefaults', this.selected_copy)
        .then(() => {
          this.$root.$snackbarSuccess('Templates copied');
          this.$store.dispatch('catalog/setSelected', []);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    ignoreResize() {
      this.saving = true;
      this.$store
        .dispatch(
          'templates/ignoreResize',
          this.selected_copy.map((x) => x.id)
        )
        .then(() => {
          this.$root.$snackbarSuccess('Templates ignored');
          this.$store.dispatch('catalog/setSelected', []);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
